import _taggedTemplateLiteral from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    &:focus-within", " {\n      ", "\n    }\n\n    &:hover&", ", *:hover ~ &", " {\n      ", "\n    }\n  "]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  &", " {\n    display: block;\n    box-sizing: border-box;\n    width: 100%;\n    height: 2px;\n    margin-top: -1px;\n\n    border-bottom-color: var(", ");\n    border-bottom-width: 1px;\n    border-bottom-style: solid;\n\n    transition-timing-function: var(", ");\n    transition-duration: 0.25s;\n    transition-property: border-bottom-color, background-color;\n\n    content: '';\n  }\n\n  ", "\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  background-color: var(", ");\n  border-bottom-color: var(", ");\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border-bottom-color: var(", ");\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { css } from 'styled-components';

var getStateColor = function getStateColor(props) {
  var color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
  if (props.disabled) return props.theme.colors.interaction.secondary.disabled;
  if (props.invalid) return props.theme.colors.ui.error;
  return props.theme.colors.interaction.secondary[color];
};

export var interactionBarSelector = '::after';
export var injectInteractionBarHoverStyles = function injectInteractionBarHoverStyles(props) {
  return css(_templateObject(), getStateColor(props, 'hover'));
};
export var injectInteractionBarActiveStyles = function injectInteractionBarActiveStyles(props) {
  return css(_templateObject2(), getStateColor(props, 'focus'), getStateColor(props, 'focus'));
};
export var injectInteractionBar = function injectInteractionBar(props) {
  return css(_templateObject3(), interactionBarSelector, getStateColor(props), props.theme.easing, !(props.disabled || props.static) && css(_templateObject4(), interactionBarSelector, injectInteractionBarActiveStyles, interactionBarSelector, interactionBarSelector, injectInteractionBarHoverStyles));
};